import {
  ForgotPasswordPage,
  ResetPasswordPage
} from '@rhino-project/ui-heroui';
import { createFileRoute, useSearch } from '@tanstack/react-router';

const ResetPasswordRoute = () => {
  const { reset_password_token } = useSearch({ strict: false }) as {
    reset_password_token?: string;
  };

  if (reset_password_token) {
    return <ResetPasswordPage />;
  }

  return <ForgotPasswordPage />;
};

export const Route = createFileRoute('/auth/reset-password')({
  component: ResetPasswordRoute
});
